import AdminConfig from './admin.vue'
import ClientView from './client.vue'

export default {
  name: 'draggablelist',
  type: 'module',
  label: 'Liste déplaçable',
  components: { admin: AdminConfig, client: ClientView },
  settings: { icon: 'mdi-drag-variant' },
}
